export const PERIOD = {
  MONTHS: 'months',
  WEEKS: 'weeks',
  DAYS: 'days',
  MINUTES: 'minutes',
} as const

export type Period = typeof PERIOD[keyof typeof PERIOD]

export const MINUTES = [1, 3, 5, 10, 15, 30, 45, 60] as const
export type Minutes = typeof MINUTES[number]
